import React from 'react';

import type { WebhookEventLog } from '../../typescript-types/webhook-event-subscriptions/webhook-event-log';
import type { WebhookEventSubscription } from '../../typescript-types/webhook-event-subscriptions/webhook-event-subscription';

import { WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE } from './webhook-event-subscription-utils';

import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

export const getWebhookSubscriberName = (
  subscription: WebhookEventSubscription | null | undefined,
) => {
  if (subscription?.subscriberType === WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE.INOVA) {
    return 'Inova';
  }
  return 'custom webhook';
};

export const WebhookEventLogLabel = ({ eventLog }: { eventLog: WebhookEventLog }) => {
  const subscriberName = getWebhookSubscriberName(eventLog.WebhookEventSubscription);
  if (eventLog.failedAt) {
    return (
      <div className="u-flex-center">
        <MaterialDesignIcon iconName={ICON_NAMES.CLOSE} />
        Failed to post applicant data to {subscriberName}
      </div>
    );
  }
  if (eventLog.successAt) {
    return (
      <div className="u-flex-center">
        <MaterialDesignIcon iconName={ICON_NAMES.CHECK} />
        Successfully posted applicant data to {subscriberName}
      </div>
    );
  }
  return null;
};
